import React from 'react';

export const RuntimeBarLegend = ({ items }: { items: [string, string][] }) => (
  <div className="grid grid-cols-[min-content_1fr] items-center gap-3 rounded-md bg-secondary-lighter p-4 text-secondary-dark stihl-text-body-sm-reg">
    {items.map(([label, color]) => (
      <React.Fragment key={label}>
        <span className={`w-5 rounded bg-${color} p-1`} />
        <span>{label}</span>
      </React.Fragment>
    ))}
  </div>
);
